__turbopack_context__.v({
  "button": "nBTcLG_button",
  "container": "nBTcLG_container",
  "content": "nBTcLG_content",
  "image": "nBTcLG_image",
  "imageContainer": "nBTcLG_imageContainer",
  "title": "nBTcLG_title",
});
